import React, {useState, useEffect} from "react";
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    Grid,
    Paper,
    FormHelperText
} from '@material-ui/core';
import { getjudgesBench } from "../Bench/BenchForm";
import DatePickerTDSAT from "features/Tdsat/components/DatePickerTDSAT";
import CourtNumberInput from "features/Tdsat/components/CourtNumberInput";
import { CASE_TYPES_WITH_LABEL } from "../Notice/NoticeCaseForm";
import { format, isValid } from "date-fns";
import { getBenchByListingDate } from "features/Tdsat/API/TdsatApi";
import validateDateAndFormat from "utils/validateDateAndFormat";
import { RequiredLabel } from "features/loginTdsat/Signup";

const YEARS = ['Select', '2021', '2022', '2023', '2024'];
const CASE_TYPE = ["ADR", "AERA", "BA", "BP", "CA", "EA", "TA", "TP"]

export const benchMap = {
    single_bench: "Single Bench",
    division_bench: "Division Bench",
    full_bench: "Full Bench",
    registrar: "Registrar"
};

const SearchByDateForm = ({classes, formData, handleInputChange, handleSearch, setFormData, benchIdResponse}) => {
    const [errors, setErrors] = useState({
        case_type_in_listing: '',
        benchNature: '',
        courtNumber: '',
        judgeName: ''
    });
    const [judges, setJudges] = useState([]);
    useEffect(() => {
        const fetchJudges = async () => {
          try {
            const response = await getjudgesBench();
            setJudges(response?.data);  
          } catch (error) {
            console.error("Error fetching judges", error);
          }
        };
    
        fetchJudges();
      }, []);

    const handleSearchClick = async () => {
        let hasError = false;
        let newErrors = {date: '', case_type_in_listing: '',  benchNature: '', courtNumber: '', judgeName: ''};

        if (!formData.date) {
            newErrors.date = 'Date is required';
            hasError = true;
        }
        // if (!formData.case_type_in_listing) {
        //     newErrors.case_type_in_listing = 'Case Type is required';
        //     hasError = true;
        // }
        if (!formData.benchNature) {
            newErrors.benchNature = 'Bench Nature is required';
            hasError = true;
        }
        if (!formData.courtNumber) {
            newErrors.courtNumber = 'Court Number is required';
            hasError = true;
        }
        // if (!formData.judgeName) {
        //     newErrors.judgeName = 'Judge Selection is required';
        //     hasError = true;
        // }

        setErrors(newErrors);

        if (!hasError) {
            handleSearch(formData);
        }
    };

    const handleDateInput = (value) => {
        console.log(value,'value')
        setFormData((prevData) => ({
          ...prevData,
          'date': value,
        }));
    }


    const [judgesOptions, setJudgesOptions] = useState([]);
    const [noJudgesFound, setNoJudgesFound] = useState(false);

    const [benchOptions, setBenchOptions] = useState([]);
    const [noBenchFound, setNoBenchFound] = useState(false);

    useEffect(()=>{
      if(formData?.courtNumber){
        formData.judgeName = judgesOptions?.find(bench => bench?.court_number === formData?.courtNumber)?.presiding_judge?.id;
      }
    },[formData?.courtNumber])

    useEffect(()=>{
      if(formData?.benchNature){
        formData.courtNumber = '';
      }
    },[formData?.benchNature])

    useEffect(()=>{
        if(formData?.date && isValid(new Date(formData?.date))){
            getBenchAndJudgesOptions(formData?.date);
        }
    },[formData?.date])

    const getBenchAndJudgesOptions = (listingDate) => {
        setNoJudgesFound(false);
        setNoBenchFound(false)
        const formatedDate = format(listingDate, 'dd-MM-yyyy')
        getBenchByListingDate(formatedDate).then((res)=>{
            const combinedJudges = res?.data?.flatMap(item => item?.judges);

            const uniqueJudges = Array?.from(new Map(combinedJudges?.map(judge => [judge?.id, judge]))?.values());

            const uniqueBenchArray = Array?.from(
                new Map(
                    res?.data?.map(item => [item?.bench_nature, {
                        label: benchMap[item?.bench_nature] || item?.bench_nature,
                        value: item?.bench_nature
                    }])
                )?.values()
            );

            setJudgesOptions(res?.data);
            setBenchOptions(uniqueBenchArray);
            if(res?.data?.length === 0){
                setNoJudgesFound(true);
                setNoBenchFound(true)
            }
        }).catch((error)=>{
            console.log('There is a glitch in getting court number: ',error);
        })
    }
    
    return(
        <Paper className={classes.paper}>
            <Grid container spacing={2}>
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth margin="none" variant="outlined">
                            <DatePickerTDSAT
                                date={formData?.date}
                                setDate={handleDateInput}
                                label="Date"
                                minimumDate={new Date()}
                                isRequired={true}
                            />
                        </FormControl>
                        {errors.date && <FormHelperText error>{errors.date}</FormHelperText>}
                    </Grid>
                    {/* <Grid item xs={6}>
                        <FormControl fullWidth margin="none" variant="outlined">
                        <Typography className={classes.label}>Case Type</Typography>
                        <Select
                            label={'Case Type'}
                            name="case_type_in_listing"
                            value={formData.case_type_in_listing}
                            onChange={handleInputChange}
                        >
                            {CASE_TYPES_WITH_LABEL.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.case_type_in_listing && <FormHelperText error>{errors.case_type_in_listing}</FormHelperText>}
                        </FormControl>
                    </Grid> */}
                    <Grid item xs={6}>
                        <FormControl className={classes.formControl} fullWidth required margin="none" variant="outlined">
                        <RequiredLabel className={classes.label} label={'Bench Nature'} />
                        <Select
                            name="benchNature"
                            value={formData.benchNature}
                            onChange={handleInputChange}
                            disabled={!formData?.date}
                        >
                            <MenuItem>Select</MenuItem>
                            {benchOptions?.map((item)=>{
                                return (
                                    <MenuItem key={item?.id} value={item?.value}>{item?.label}</MenuItem>
                                )
                            })}
                        </Select>
                        {errors.benchNature && <FormHelperText error>{errors.benchNature}</FormHelperText>}
                        {noBenchFound && <Typography align='left' color='error'>{'No Bench is there on this listing date. Please select another date.'}</Typography>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <CourtNumberInput
                            courtNumber={formData.courtNumber}
                            onChange={handleInputChange}
                            listingDate={formData.date}
                            isRequired={true}
                            benchNature={formData?.benchNature}
                        />
                        {errors.courtNumber && <FormHelperText error>{errors.courtNumber}</FormHelperText>}
                    </Grid>
                    {/* <Grid item xs={6}>
                        <FormControl fullWidth margin="none" variant="outlined">
                        <Typography className={classes.label}>Judge Name</Typography>
                        <Select
                            label={'Judge Name'}
                            name="judgeName"
                            value={formData.judgeName}
                            onChange={handleInputChange}
                        >
                            {judgesOptions?.map((judge) => (
                              <MenuItem key={judge.id} value={judge.id}>
                                  {judge?.name}
                              </MenuItem>
                            ))}
                        </Select>
                        {errors.judgeName && <FormHelperText error>{errors.judgeName}</FormHelperText>}
                        {noJudgesFound && <Typography align='left' color='error'>{'No Judge is there on this listing date. Please select another date.'}</Typography>}
                        </FormControl>
                    </Grid> */}
                </Grid>
            </Grid>
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 18 }}>
            <Button
                variant="contained"
                color="primary"
                fullWidth
                className={classes.button}
                onClick={()=>handleSearchClick(formData)}
            >
                Search
            </Button>
            </Grid>

            {(benchIdResponse?.length > 0) && (
							<Grid container style={{width:'100%', textAlign:'left', marginTop:'1rem', padding:'1rem', border:'1px solid #e9e9e9'}}>
								<Grid item>
									<Typography>Listing Date: {isValid(benchIdResponse?.[0]?.listing_date_timestamp) ? validateDateAndFormat(benchIdResponse?.[0]?.listing_date_timestamp, 'dd/MM/yyyy') : benchIdResponse?.[0]?.listing_date_timestamp}</Typography>
									<Typography>Bench Nature: {benchMap[benchIdResponse?.[0]?.bench_nature]}</Typography>
									<Typography>Court Number: {benchIdResponse?.[0]?.court_number}</Typography>
                                    <Typography style={{textTransform:'uppercase'}}>
                                        {benchIdResponse?.[0]?.presiding_judge?.name} {''}
                                        {((benchIdResponse?.[0]?.judges?.length > 1))
                                            ? <span style={{color:'red'}}>(Presiding Judge)</span> 
                                            : null}
                                    </Typography>
									{benchIdResponse?.[0]?.judges?.filter(element => element?.id !== benchIdResponse?.[0]?.presiding_judge?.id)?.map((judge, index)=>{
										return (
											<Typography key={index} style={{textTransform:'uppercase'}}>
												{judge?.name} {''}
											</Typography>
										)
									})}
								</Grid>
							</Grid>
            )}
        </Paper>
    )
}

export default SearchByDateForm;